__webpack_require__.p = "/wp-content/themes/hello-elementor-child/dist/";